// extracted by mini-css-extract-plugin
export var active = "_k4-2";
export var recordingDot = "_k4-1";
export var recordingIndicator = "_k4-0";